export default {
  Account: '賬號',
  Password: '密碼',
  Or: '或者',
  Next: '下一步',
  Re_send: '重新發送',
  Email: '郵箱地址',

  login_dialog: {
    google_login: '繼續使用 Google 登入',
    apple_login: '繼續使用 Apple 登入',
    email_login: '繼續使用 郵箱 登入',
    account_login: '繼續使用 賬號密碼 登入',
    code_has_send: '驗證碼已發送至 {account}'
  }
}
